import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { qulifications } from './qualification.js';

// DigiLocker only accepts alphabets, numbers, spaces, and underscores for purpose/service_name.
const sanitizeConsentText = (value, fallback) => {
  const cleaned = (value || "").replace(/[^A-Za-z0-9 _]/g, "").trim();
  return cleaned || fallback;
};

function AllowPermission() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState({});
  const [qualificationData, setQualificationData] = useState([]);

  const handleConsent = () => {
    // ZiXqEAZS72y8u2efZj3VV54E_0GfEQfsWnoxygIshD4
    // https://digilocker.meripehchaan.gov.in/public/oauth2/1/authorize?response_type=code&client_id=KVF48840D7&state=oidc_flow&redirect_uri=https%3A%2F%2Findia.verify.vasuniverse.com%2Fdigilocker&code_challenge=ZiXqEAZS72y8u2efZj3VV54E_0GfEQfsWnoxygIshD4&code_challenge_method=S256&dl_flow=signin&pla=Y
    // https://digilocker.meripehchaan.gov.in/signin/oauth_partner/%252Foauth2%252F1%252Fconsent%253Flogo%253D%2526pla%253DY%2526response_type%253Dcode%2526client_id%253DKVF48840D7%2526state%253Doidc_flow%2526redirect_uri%253Dhttps%25253A%25252F%25252Findia.verify.vasuniverse.com%25252Fdigilocker%2526code_challenge%253Dhttps%25253A%25252F%25252Findia.verify.vasuniverse.com%25252Fdigilocker%2526code_challenge_method%253DS256%2526orgid%253D061500%2526txn%253D66e2eb26be732oauth21726147366%2526hashkey%253D30c0ee4e3edea50ca0c36ad8d364d0b23a81a760c2cd1f2086164b6ca5ffd7b6%2526requst_pdf%253DY%2526app_name%253DVkFTIERldg%25253D%25253D%2526signup%253Dsignup
    // const url = `${process.env.REACT_APP_DIGILOKER_API}?response_type=code&client_id=${process.env.REACT_APP_CLIENT_ID}&state=oidc_flow&redirect_uri=${encodeURIComponent(process.env.REACT_APP_REDIRECT_URL)}&code_challenge=${process.env.REACT_APP_REDIRECT_URL}&code_challenge_method=S256&dl_flow=signin&pla=Y`;
    // https://digilocker.meripehchaan.gov.in/public/oauth2/1/authorize?response_type=code&client_id=KVF48840D7&state=oidc_flow&redirect_uri=https%3A%2F%2Findia.verify.vasuniverse.com%2Fdigilocker&code_challenge=7r96qmCQdqq1YzszEfypoJCWJt-vdVG6XZl4XlmdWLs&code_challenge_method=S256&scope=files.issueddocs

    // window.location.href = 'https://digilocker.meripehchaan.gov.in/public/oauth2/1/authorize?response_type=code&client_id=KVF48840D7&state=oidc_flow&redirect_uri=https%3A%2F%2Findia.verify.vasuniverse.com%2Fdigilocker&code_challenge=ZiXqEAZS72y8u2efZj3VV54E_0GfEQfsWnoxygIshD4&code_challenge_method=S256&dl_flow=signin&pla=Y';
    const purpose = sanitizeConsentText(userData.purpose, "Document Verification");
    const service_name = sanitizeConsentText(userData.service_name, "Virtual Admission System");
    const authorizeUrl = 'https://digilocker.meripehchaan.gov.in/public/oauth2/1/authorize?response_type=code&client_id=KVF48840D7&state=oidc_flow&redirect_uri=https%3A%2F%2Findia.verify.vasuniverse.com%2Fdigilocker&code_challenge=y9KekKDYh8he2hXfEor9p9y0pE-SMI3FdC7T0a6ErpY&code_challenge_method=S256&dl_flow=signin&acr=mobile+aadhaar&amr=aadhaar&scope=files.issueddocs&pla=Y'
      + `&purpose=${encodeURIComponent(purpose)}&service_name=${encodeURIComponent(service_name)}`;
    window.location.href = authorizeUrl;
  };

  useEffect(() => {
    try {
      const { name, application_id, token, purpose, service_name, params } = JSON.parse(sessionStorage.getItem("user_data"));
      const items = params.map(row => {
        const { orgid, documentTypes } = row;
        const rowItems = qulifications[orgid];
        const _documentTypes = documentTypes.map(dt => rowItems.find(ri => ri.documentType === dt));
        return {
          ...row,
          university: _documentTypes[0].university,
          documentTypes: _documentTypes
        }
      });
      setQualificationData(items)
      setUserData({
        name: name,
        application_id: application_id,
        token: token,
        purpose: purpose,
        service_name: service_name,
        params: params,
        items: items
      })
    } catch (e) {
      sessionStorage.clear();
      navigate('/error');
    }

    // const searchParams = new URLSearchParams(location.search);
    // const user_name = searchParams.get("user_name");
    // const application_id = searchParams.get("application_id");
    // const token = searchParams.get("token");
    // if (user_name && application_id) {
    //   setUserData({
    //     user_name: user_name,
    //     application_id: application_id,
    //     token: token
    //   });
    // }
  }, [navigate]);

  // useEffect(() => {
  //   if (userData.user_name && userData.application_id) {
  //     localStorage.setItem("user_data", JSON.stringify(userData));
  //   }
  // }, [userData]);

  const listItems = qualificationData.map((item, index) => <li key={index}>I provide my consent to share my Aadhaar Number, Date of Birth and Name from my
    Aadhaar eKYC information with the <b>{item.university}</b> for the purpose of fetching my <b>{item.documentTypes.map(d => d.documentDescription).join(', ')}</b> into DigiLocker.</li>);



  return (
    <div className="container">
      <div className="header">
        <img
          src={
            "https://www.digilocker.gov.in/assets/img/digilocker_logo_new.png"
          }
          className="App-logo"
          alt="logo"
        />

        <h2>Grant Access to Your Documents</h2>
      </div>
      <div className="content">
        <h3>Virtual Admission System is requesting the following access:</h3>
        <ul className="permissions">
          {listItems}
        </ul>
        <h4>Name: {userData?.name}</h4>
        <p>
          Please review the permissions above. By granting access, you allow
          Virtual Admission System to retrieve and verify your documents from DigiLocker as
          described.
        </p>
      </div>
      <div className="actions">
        <button className="allow" onClick={handleConsent}>
          Allow
        </button>
        <button className="deny">Deny</button>
      </div>
    </div>
  );
}

export default AllowPermission;
